import { render, staticRenderFns } from "./EmailPasswordLogin.vue?vue&type=template&id=64567cb5"
import script from "./EmailPasswordLogin.vue?vue&type=script&lang=js"
export * from "./EmailPasswordLogin.vue?vue&type=script&lang=js"
import style0 from "./EmailPasswordLogin.vue?vue&type=style&index=0&id=64567cb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports